import EfEndorsements from '@elem/ui/ef-endorsements';
import EfSpec from '@elem/ui/ef-spec';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SwiperA');
    const listA = [
        {
            text: t('text1'),
            title: t('swiper_title1'),
        },
        {
            text: t('text2'),
            title: t('swiper_title2'),
        },
        // {
        //     logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658862/USA%20Today%20(1).png',
        //     text: "The most powerful PPSs on the market now rival their gas counterparts.The upcoming launch of the EcoFlow DELTA Pro 3 this surmmer marks significant advancement in home backup power solutions,amplifying EcoFlow's already impressive lineup.",
        // },
        // {
        //     logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658871/CNN%202.png',
        //     text: "The latest DELTA Pro 3, slated for a summer 2024 release, will further enhance these features, establishing it as the brand's flagship solution for energy independence and sustainability.",
        // },
        // {
        //     logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658871/Good%20Housekeeping%20(1)%201.png',
        //     text: 'The combination of portability and quiet operation offers up almost infinite possibilities.',
        // },
        // {
        //     logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658947/BobVila%201.png',
        //     text: "Its wide utility makes it one of the most versatile power stations available, and it's a great asset for any power-hungry DIYfer.",
        // },
    ];
    return (
        <div className={styles.TheComp} id={PageNavType.Why}>
            <EfSpec />
            <EfEndorsements title={t('title')} lists={listA} />
        </div>
    );
}
